import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AICallSummaryModel extends BaseModel {
  static urlPath = "ai/call_summary/user_stats";

  @attr("number") unreadCount;
  @attr("number") unseenCount;
}
